import { render, staticRenderFns } from "./ChartWrapper.vue?vue&type=template&id=491a64fc&scoped=true&"
import script from "./ChartWrapper.vue?vue&type=script&lang=js&"
export * from "./ChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a64fc",
  null
  
)

export default component.exports